import { c as _c } from "react/compiler-runtime";
import type { CSSProperties, FC, MouseEventHandler } from 'react';
import { lightTheme, type ThemeColor } from '../../themes';
import { StyledSvg } from './Icon.style';
import { type IconName, icons } from './icons';
export type IconSize = 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
export type IconProps = {
  icon: IconName;
  size?: IconSize;
  width?: number;
  height?: number;
  viewbox?: string;
  color?: ThemeColor;
  alt: string;
  ariaHidden?: boolean;
  onClick?: MouseEventHandler<SVGSVGElement>;
  style?: CSSProperties;
  hideTooltip?: boolean | undefined;
  children?: React.ReactNode;
  inheritColor?: boolean;
  className?: string;
};
export const Icon: FC<IconProps> = t0 => {
  const $ = _c(17);
  const {
    icon,
    size: t1,
    width,
    height,
    viewbox: t2,
    color,
    alt,
    ariaHidden: t3,
    onClick,
    style,
    hideTooltip,
    inheritColor: t4,
    className
  } = t0;
  const size = t1 === undefined ? "s" : t1;
  const viewbox = t2 === undefined ? "0 0 24 24" : t2;
  const ariaHidden = t3 === undefined ? false : t3;
  const inheritColor = t4 === undefined ? false : t4;
  const iconColor = color ? lightTheme.colors[color] : lightTheme.colors.typeSecondary;
  const IconComponent = icons[icon];
  const useSizing = !width || !height;
  let sizing = 12;
  if (size === "s") {
    sizing = 24;
  }
  if (size === "m") {
    sizing = 48;
  }
  if (size === "l") {
    sizing = 72;
  }
  if (size === "xl") {
    sizing = 96;
  }
  if (size === "xxl") {
    sizing = 236;
  }
  const t5 = useSizing ? sizing : width;
  const t6 = useSizing ? sizing : height;
  const t7 = inheritColor ? undefined : iconColor;
  let t8;
  if ($[0] !== alt || $[1] !== hideTooltip) {
    t8 = !hideTooltip && <title>{alt}</title>;
    $[0] = alt;
    $[1] = hideTooltip;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  let t9;
  if ($[3] !== IconComponent) {
    t9 = <IconComponent />;
    $[3] = IconComponent;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  let t10;
  if ($[5] !== alt || $[6] !== ariaHidden || $[7] !== className || $[8] !== onClick || $[9] !== style || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== t8 || $[14] !== t9 || $[15] !== viewbox) {
    t10 = <StyledSvg aria-hidden={ariaHidden} role="img" fill="none" aria-label={alt} width={t5} height={t6} viewBox={viewbox} xmlns="http://www.w3.org/2000/svg" color={t7} onClick={onClick} style={style} className={className}>{t8}{t9}</StyledSvg>;
    $[5] = alt;
    $[6] = ariaHidden;
    $[7] = className;
    $[8] = onClick;
    $[9] = style;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
    $[15] = viewbox;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};